export default __webpack_public_path__ + "static/media/empty_scr.3965e574.png";